<div class="container " style="min-height: 80vh">
  <table mat-table [dataSource]="keycloakOrganizations()" class="mat-elevation-z8">

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Name</th>
      <td mat-cell *matCellDef="let element"> {{ element.name }}</td>
    </ng-container>

    <ng-container matColumnDef="tenant">
      <th mat-header-cell *matHeaderCellDef>tenant</th>
      <td mat-cell *matCellDef="let element"> {{ element.tenant }}</td>
    </ng-container>

    <ng-container matColumnDef="action">
      <th class="" mat-header-cell *matHeaderCellDef></th>
      <td class="" mat-cell *matCellDef="let element">
        <button mat-icon-button type="button" class="" title="Edit organization" (click)="onEdit(element)">
          <mat-icon>edit</mat-icon>
        </button>
        <button mat-icon-button type="button" class="" title="Delete organization" (click)="onDelete(element)">
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <button class="mt-3" mat-raised-button (click)="onCreate()">
    Create organization
    <mat-icon>add_circle</mat-icon>
  </button>

</div>
